import { React, useState, useEffect } from "react";
import useMeta from '../../../hooks/useMeta';

import './VideoPageUI.css'

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import Footer from "../../../CommonComponent/Footer/footer";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

import { VideoPage_Data } from "../VideoPage_Data";

import { useNavigate, useParams, Link, useLocation } from "react-router-dom";



const VideoPage_UI = () => {

    const { Video_PageID } = useParams();

    const CurrentVid_Page = VideoPage_Data[Video_PageID] || null;

    const Col1_Title = CurrentVid_Page?.VID_Col1_title || null;
    const vid_embed_src = CurrentVid_Page?.VID_embed_src || null;
    const VP_info_title = CurrentVid_Page?.VID_info_title || null;
    const VP_info_dec = CurrentVid_Page?.VID_info_dec || null;
    const VID_Suggestions = CurrentVid_Page?.VID_Suggestions || null;
    const VID_Current_index = CurrentVid_Page?.VID_Current_index || null;


    const META_PG_OG_Title = CurrentVid_Page?.META_PG_OG_Title || '';
    const META_PG_OG_Description = CurrentVid_Page?.META_PG_OG_Description || 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.';
    const META_PG_Canonical_OG_URL = CurrentVid_Page?.META_PG_Canonical_OG_URL || '';

    useMeta({
        title: `${META_PG_OG_Title}`,
        description: `${META_PG_OG_Description}`,
        canonical: `${META_PG_Canonical_OG_URL}`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: `${META_PG_OG_Title}`,
            description: `${META_PG_OG_Description}`,
            url: `${META_PG_Canonical_OG_URL}`,
            site_name: 'Callistus Blinds',
        },
    });

    const VP_Suggestions1 = [
        {
            link: "/videos/luzon-blinds",
            image: "/Assets/VidGalleryImages/luzon-inspiration-17.webp",
            title: "Luzon Blinds",
            description: "Callistus Luzon Blinds combine alternating sheer and solid fabric bands in a single shade."
        },
        {
            link: "/videos/colby-blinds-by-callistus-window-fashion",
            image: "/Assets/VidGalleryImages/colby-15.webp",
            title: "Colby Blinds by Callistus Window Fashion",
            description: "Most Energy Efficient Blinds."
        },
        {
            link: "/videos/callistus-panel-blinds",
            image: "/Assets/VidGalleryImages/panel_thumb_video.webp",
            title: "Callistus Panel Blinds",
            description: "Make a statement and enhance your space with Callistus Panel blinds"
        },
        {
            link: "/videos/new-window-nice",
            image: "/Assets/VidGalleryImages/Grayson-07.webp",
            title: "Grayson Blinds",
            description: "Grayson blinds gives you ultimate privacy with a view to the outside."
        },
        {
            link: "/videos/wooden-venetian",
            image: "/Assets/VidGalleryImages/wooden-inspiration-02.webp",
            title: "Wooden Venetian Blinds",
            description: "Wooden Venetian blinds offers experience timeless luxury."
        }
    ]

    const VP_Suggestions2 = [
        {
            link: "/videos/wooden-venetian-manual",
            image: "/Assets/VidGalleryImages/Wooden_thumb_video.webp",
            title: "Wooden Venetian Manual",
            description: "Callistus Wooden Venetian Blinds add a timeless style to your windows.",
        },
        {
            link: "/videos/roller-blinds-one-touch-up",
            image: "/Assets/VidGalleryImages/Roller_thumb_video.webp",
            title: "Roller Blinds One Touch Up",
            description: "Gently diffusing the light to create an astonishing ambiance Callistus Roller Blinds can enlighten any space with its colour, design and texture.",
        },
        {
            link: "/videos/colby-blinds-top-down-bottom-up-tdbu",
            image: "/Assets/VidGalleryImages/Colby_thumb_video.webp",
            title: "Colby Blinds Top Down Bottom Up (TDBU)",
            description: "Most energy efficient blinds specifically engineered to provide beauty and energy efficiency in both cold and warm climates.",
        },
        {
            link: "/videos/patricia-blind-automation",
            image: "/Assets/VidGalleryImages/Patricia_thumb_video.webp",
            title: "Patricia Blind Automation",
            description: "Patricia Blinds are luxurious to look at and are the latest trendsetter in interior designing.",
        }
    ];

    const location = useLocation();
    const [previousPage, setPreviousPage] = useState(null);

    const osPages = [
        "wooden-venetian-manual",
        "roller-blinds-one-touch-up",
        "colby-blinds-top-down-bottom-up-tdbu",
        "patricia-blind-automation",
    ];

    const productPages = [
        "luzon-blinds",
        "colby-blinds-by-callistus-window-fashion",
        "callistus-panel-blinds",
        "new-window-nice",
        "wooden-venetian",
    ];

    useEffect(() => {
        if (location.state?.from) {
            setPreviousPage(location.state.from);
        }
    }, [location]);



    const navigate = useNavigate();


    const [selectedOption, setSelectedOption] = useState('');

    const handleDropdownChange = (e) => {
        const value = e.target.value;
        setSelectedOption(value);
        if (value) {
            navigate(value);
        }
    };

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="vp-container">
                <div className="vp-header">
                    <h1 className="vp-page-title">VIDEOS</h1>
                </div>
                <div className="vp-dropdown-container">
                    <select
                        className="vp-dropdown"
                        value={selectedOption}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSelectedOption(value);

                            if (value === "product") {
                                // If on OS page, go to previous product or default
                                if (osPages.includes(Video_PageID)) {
                                    if (previousPage && productPages.includes(previousPage.split("/").pop())) {
                                        navigate(previousPage);
                                    } else {
                                        navigate("/videos/luzon-blinds");
                                    }
                                }
                            } else if (value === "os") {
                                // If on product page, go to previous OS or default OS
                                if (productPages.includes(Video_PageID)) {
                                    if (previousPage && osPages.includes(previousPage.split("/").pop())) {
                                        navigate(previousPage);
                                    } else {
                                        navigate("/videos/wooden-venetian-manual");
                                    }
                                }
                            } else {
                                // Navigating between specific paths
                                navigate(value, { state: { from: `/videos/${Video_PageID}` } });
                            }
                        }}
                    >
                        {productPages.includes(Video_PageID) ? (
                            <>
                                <option value="product">Product</option>
                                <option value="os">Operating System</option>
                            </>
                        ) : (
                            <>
                                <option value="os">Operating System</option>
                                <option value="product">Product</option>
                            </>
                        )}

                    </select>
                </div>

                <div className="vp-content">
                    <div className="vp-main-column">
                        {Col1_Title != null && (
                            <div className="vp-video-col-title">
                                <h2>{Col1_Title}</h2>
                            </div>
                        )}
                        <div className="vp-video-container">
                            <iframe
                                className="vp-video"
                                src={vid_embed_src}
                            ></iframe>
                        </div>

                        <div className="vp-video-info">
                            <h3 className="vp-video-title">{VP_info_title}</h3>
                            <p className="vp-video-description">
                                {VP_info_dec}
                            </p>
                        </div>
                    </div>

                    <div className="vp-sidebar">
                        <h3 className="vp-sidebar-title">You May Also Like</h3>
                        {VID_Suggestions === 1 && (
                            VP_Suggestions1.filter((_, index) => index != VID_Current_index - 1).map((vp_card, index) => (
                                <Link to={vp_card.link} key={index}>
                                    <div className="vp-card">
                                        <div className="vp-card-image">
                                            <img src={vp_card.image} alt={vp_card.title} />
                                        </div>
                                        <h4 className="vp-card-title">{vp_card.title}</h4>
                                        <p className="vp-card-description">{vp_card.description}</p>
                                    </div>
                                </Link>
                            ))
                        )}

                        {VID_Suggestions === 2 && (
                            VP_Suggestions2.filter((_, index) => index != VID_Current_index - 1).map((vp_card, index) => (
                                <Link to={vp_card.link} key={index}>
                                    <div className="vp-card">
                                        <div className="vp-card-image">
                                            <img src={vp_card.image} alt={vp_card.title} />
                                        </div>
                                        <h4 className="vp-card-title">{vp_card.title}</h4>
                                        <p className="vp-card-description">{vp_card.description}</p>
                                    </div>
                                </Link>
                            ))
                        )}
                    </div>

                </div>
            </div>
            <Footer />
        </>
    );
}

export default VideoPage_UI;